import {
  API_ERROR,
  PRODUCT_GROUPS,
  PRODUCT_GROUPS_LIST_SUCCESSFUL,
  SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  PRODUCT_GROUPS_ADD,
  PRODUCT_GROUPS_ADD_SUCCESSFUL,
  PRODUCT_GROUPS_ROW_DATA,
  PRODUCT_GROUPS_ROW_DATA_SUCCESSFUL,
  PRODUCT_GROUPS_DELETE,
  PRODUCT_GROUPS_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  SET_PARAMS
} from "./actionTypes";

export const getProductGroups = (data) => {
  return {
    type: PRODUCT_GROUPS,
    payload: { data },
  };
};

export const productGroupsListSuccessful = (ProductGroup) => {
  return {
    type: PRODUCT_GROUPS_LIST_SUCCESSFUL,
    payload: ProductGroup,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};

export const ProductGroupAdd = (data) => {
  return {
    type: PRODUCT_GROUPS_ADD,
    payload: { data },
  };
};

export const ProductGroupAddSuccessful = (response) => {
  return {
    type: PRODUCT_GROUPS_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const ProductGroupRowData = (GroupData) => {
  return {
    type: PRODUCT_GROUPS_ROW_DATA,
    payload: { GroupData },
  };
};

export const  ProductGroupRowSuccessful = (response) => {
  return {
    type: PRODUCT_GROUPS_ROW_DATA_SUCCESSFUL,
    payload: response,
  };
};

export const ProductGroupDelete = (pGroupID) => {
  return {
    type: PRODUCT_GROUPS_DELETE,
    payload: { pGroupID },
  };
};

export const SetEditData = (data) => {
  return {
    type: PRODUCT_GROUPS_SETROWDATA,
    payload: data,
  };
};

export const pGroupModel_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
